import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IonContent, NavController, Platform } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { CustomerModel } from "src/app/models/customer-model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import {
  PASSWORD_PATTERN,
} from "src/app/services/customFormValidators";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";

@Component({
  selector: "change-password-mfa-step-two",
  templateUrl: "./change-password-mfa-step-two.component.html",
  styleUrls: ["./change-password-mfa-step-two.component.scss"],
})
export class ChangePasswordMFAStepTwoComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() callBackFn: () => void;

  public error: any = null;
  public passwordForm: FormGroup;

  public customer: CustomerModel;

  public currentPassword: AbstractControl;
  public passwordGroup: AbstractControl;
  public newPassword: AbstractControl;
  public confirmPassword: AbstractControl;
  public secondSecurityAnswer: AbstractControl;
  public customerWillRedirect: boolean = false;

  constructor(
    // public logger: Logger,
    public navCtrl: NavController,
    public authService: AuthenticationService,
    public userSession: UserSessionService,
    public successMessageService: SuccessMessageService,
    protected config: ConfigService,
    public events: EventsService,
    public navigator: Navigator,
    public platform: Platform
  ) {
    this.successMessageService.clearMessage();

    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });
  }

  ngOnInit() {
    this.passwordForm = new FormGroup({
      currentPassword: new FormControl("", [Validators.required]),
      passwordGroup: new FormGroup(
        {
          newPassword: new FormControl("", [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(PASSWORD_PATTERN),
          ]),
          confirmPassword: new FormControl("", [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(PASSWORD_PATTERN),
          ]),
        },
        this.passwordMatchValidator
      ),
    });

    this.currentPassword = this.passwordForm.get("currentPassword");
    this.passwordGroup = this.passwordForm.get("passwordGroup");
    this.newPassword = this.passwordGroup.get("newPassword");
    this.confirmPassword = this.passwordGroup.get("confirmPassword");
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get("newPassword").value === g.get("confirmPassword").value
      ? null
      : { mismatch: true };
  }

  ionViewDidLeave() {
    if (this.customerWillRedirect == true) {
      this.events.publish("event:appInit:next");
    }
  }

  onSubmit() {
    this.error = null;
    this.successMessageService.clearMessage();
      //Normal ChangePassword Call
      this.authService.callChangePassword(this.passwordForm.value).subscribe({
        next: (response: any) => {
          if (response && !!response.result) {
            this.error = null;
            this.successMessageService.setMessage(
              "Your password has been changed."
            );

            this.content.scrollToTop();
          }
        },
        error: (error) => {
          switch (error.getErrorCode().toUpperCase()) {
            case "CURRENT_PASS_FAIL":
              error.setErrorMessage(
                "You have incorrectly entered your current password."
              );
              this.currentPassword.setErrors({ CURRENT_PASS_FAIL: true });
              this.currentPassword.markAsDirty();
              this.currentPassword.markAsTouched();
              break;
            case "CURRENT_PASS_NO_MATCH":
              error.setErrorMessage(
                "Your new password can not match your current password."
              );
              this.passwordGroup.setErrors({ CURRENT_PASS_NO_MATCH: true });
              this.passwordGroup.markAsDirty();
              this.passwordGroup.markAsTouched();
              break;
          }
          this.error = error;
          this.content.scrollToTop(10);
        }
    });
  }

  closeModal = () => {
      if (this.callBackFn) {
        this.callBackFn();
      } else {
        this.events.publish("event:appInit:next");
      }
  };
}
